import { render, staticRenderFns } from "./MaximosMinimosIndex.vue?vue&type=template&id=f4e82f34&scoped=true&"
import script from "./MaximosMinimosIndex.vue?vue&type=script&lang=ts&"
export * from "./MaximosMinimosIndex.vue?vue&type=script&lang=ts&"
import style0 from "./MaximosMinimosIndex.vue?vue&type=style&index=0&id=f4e82f34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e82f34",
  null
  
)

export default component.exports